import { useEffect, useState } from "react";
import { PriceAdjustmentSuggestion } from "../api/PriceAdjustmentSuggestionApi";

const usePriceAdjustmentSuggestions = (fetchPriceAdjustmentSuggestions: () => Promise<PriceAdjustmentSuggestion[]>) => {
  const [priceAdjustmentSuggestions, setPriceAdjustmentSuggestions] = useState<PriceAdjustmentSuggestion[]>();

  const fetchPriceAdjustments = () => {
    fetchPriceAdjustmentSuggestions()
      .then(setPriceAdjustmentSuggestions)
      .catch(reason => console.error(`Could not fetch suggested form price adjustments: ${reason}`));
  };

  useEffect(fetchPriceAdjustments, []);
  
  return {
    findPriceAdjutmentSuggestionForVolume : (volume: number) : number|undefined => {
      let matchingPriceAdjustmentSuggestion: PriceAdjustmentSuggestion|null = null;
      if (priceAdjustmentSuggestions !== undefined) {
        for (let priceAdjustmentSuggestion of priceAdjustmentSuggestions) {
          const maxVolume = priceAdjustmentSuggestion.maximumVolume;
          matchingPriceAdjustmentSuggestion = priceAdjustmentSuggestion;
          if (maxVolume === undefined || volume <= maxVolume) {
            break;
          }
        }
        return matchingPriceAdjustmentSuggestion?.priceAdjustmentPercent;
      };
    }
  }
};
export default usePriceAdjustmentSuggestions;